/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Integrations_DescInputs */

const en_ui_integrations_desc = /** @type {(inputs: Ui_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect a platform and new sessions arrive on their own`)
};

const de_ui_integrations_desc = /** @type {(inputs: Ui_Integrations_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde eine Plattform – neue Einheiten kommen dann von selbst`)
};

/**
* | output |
* | --- |
* | "Connect a platform and new sessions arrive on their own" |
*
* @param {Ui_Integrations_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_integrations_desc = /** @type {((inputs?: Ui_Integrations_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Integrations_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_integrations_desc(inputs)
	return de_ui_integrations_desc(inputs)
});